// extracted by mini-css-extract-plugin
export default {"container":"Preview_container__qRwJE","preview":"Preview_preview__YTj+Z","loading":"Preview_loading__I3FgT","icon":"Preview_icon__dq70p","title":"Preview_title__-Jg4l"};